
import { all, fork } from 'redux-saga/effects';

import * as authenticationSaga from '../auth/AuthenticationSaga';
import * as confirmationSaga from '../helper/confirmation-modal/confirmationSaga'
import * as estoqueSaga from '../estoque/EstoqueSaga'
import * as clientesSaga from '../clientes/ClientesSaga'
import * as relatorioSaga from '../relatorios/RelatorioSaga'


export default function* rootSaga() {
    yield all([
        ...Object.values(authenticationSaga),
        ...Object.values(confirmationSaga),
        ...Object.values(estoqueSaga),
        ...Object.values(clientesSaga),
        ...Object.values(relatorioSaga)
    ].map(fork))
}

